// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__RQcvq","addButton":"Table_addButton__PQvA5","addButtonIcon":"Table_addButtonIcon__d4OQ4"};